module.exports = __webpack_public_path__ + "img/ma-bottom.97cf8228.png";